import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import { Paper, Typography } from "@mui/material";
import { SearchBar } from "src/chamber/features/dashboard/ui/SearchBar";
import { useState } from "react";
import ComplaintRedirector from "src/chamber/features/dashboard/ui/ComplaintRedirector";
import AssistantPhotoOutlinedIcon from "@mui/icons-material/AssistantPhotoOutlined";

type TComplaintProps = {
  activeComplaintApplications: number | null;
  pendingComplaintApplications: number | null;
  pastComplaintApplications: number | null;
  isOrgAdmin: boolean;
  isSampleInitiator: boolean;
  chamberUsers: { label: string; value: number; isChamberAdmin: boolean }[];
  violationTypes: { label: string; value: number }[];
  complaintStatuses: {
    label: string;
    value: number;
  }[];
  activeOwnComplaintsCount: number | null;
  unassignedComplaintsCount: number | null;
  countsLoading?: boolean;
};

function Complaint(props: TComplaintProps) {
  const { t } = useTranslation();
  const [protocol, setProtocol] = useState("");
  const [gemi, setGemi] = useState("");
  return (
    <Paper sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "1rem",
        }}
      >
        <Typography
          variant="h5"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <AssistantPhotoOutlinedIcon />
          {t("Καταγγελίες")}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 2,
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <SearchBar
          mode={"complaint"}
          protocol={protocol}
          gemi={gemi}
          setProtocol={setProtocol}
          setGemi={setGemi}
        />
      </Box>

      <ComplaintRedirector
        countsLoading={props.countsLoading}
        violationTypes={props.violationTypes}
        chamberUsers={props.chamberUsers}
        isOrgAdmin={props.isOrgAdmin}
        isSampleInitiator={props.isSampleInitiator}
        complaintStatuses={props.complaintStatuses}
        activeComplaintApplicationsCount={props.activeOwnComplaintsCount}
        pendingComplaintApplicationsCount={props.unassignedComplaintsCount}
      />
    </Paper>
  );
}

export default Complaint;
